export default {
  EXPLORE_PROJECTIONS: [
    'categories',
    'coach',
    'collaborators',
    'completedAt',
    'contentType',
    'createdAt',
    'description',
    'executedAt',
    'executedBy',
    'impactEndsAt',
    'impactStartsAt',
    'name',
    'organization',
    'owner',
    'review',
    'site',
    'status',
    'tags',
    'validatedReview',
    'validations',
    'afterPhase',
    'beforePhase',
    'completedBy',
    'relate',
    'expand',
    'siteGroups',
  ],
  EXPLORE_EXPANSIONS: [
    'createdBy',
    'completedBy',
    'coach',
    'collaborators',
    'organization',
    'owner',
    'site',
    'tags',
    'routine',
    'assignees',
  ],
  VIEW_STATES: {
    FILTERS: 'filters',
    LOADING: 'loading',
    IMPORTED: 'imported',
    ERROR: 'error',
    EMPTY: 'empty',
  },
  DEFAULT_COLUMNS_BY_TYPE: {
    improvementIdea: [
      'contentType',
      'title',
      'link',
      'status',
      'validations',
      'location',
      'tags',
      'categories',
      'createdAt',
      'completedAt',
      'owner',
      'coach',
      'collaborators',
      'phases',
      'plan',
      'adjust',
      'review',
    ],
    quickAction: [
      'contentType',
      'title',
      'link',
      'status',
      'validations',
      'location',
      'tags',
      'categories',
      'createdAt',
      'completedAt',
      'owner',
      'coach',
      'collaborators',
      'phases',
      'before',
      'after',
      'review',
    ],
    problemSolving: [
      'contentType',
      'title',
      'link',
      'status',
      'validations',
      'location',
      'tags',
      'categories',
      'createdAt',
      'completedAt',
      'owner',
      'coach',
      'collaborators',
      'phases',
      'define',
      'improveControl',
      'review',
    ],
    finding: [
      'contentType',
      'title',
      'link',
      'priority',
      'status',
      'createdAt',
      'completedAt',
      'assignees',
      'categories',
      'routine',
      'location',
      'tags',
    ],
    routine: [
      'contentType',
      'title',
      'link',
      'status',
      'location',
      'tags',
      'executedBy',
      'description',
      'executedAt',
      'completedAt',
    ],
  },
  DEFAULT_EXPLORE_FILTERS: {
    types: [],
    status: [],
    assignees: [],
    categories: [],
    createdAt: null,
    createdAtOption: null,
    dueDate: [],
    dueDateOption: null,
    sites: [],
    siteGroups: [],
    tags: [],
    tagGroups: [],
    countryCodes: [],
    hasFinancialValidation: null,
    hasImplementationValidation: null,
  },
}
